(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-list.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-2023/assets/javascripts/draw-selector-list.js');

'use strict';

const DrawCardContainer = svs.components.tipsen.drawCard.DrawCardContainer;
const DRAW_CARD_VARIANTS = svs.components.tipsen.drawCard.constants.DRAW_CARD_VARIANTS;
const DrawSelectorLinkItem = svs.components.tipsen.drawSelector.DrawSelectorLinkItem;
const composeDrawTitleForAnalytics = svs.components.tipsen.drawSelector.composeDrawTitleForAnalytics;
const DrawSelectorList = _ref => {
  let branding = _ref.branding,
    _ref$draws = _ref.draws,
    draws = _ref$draws === void 0 ? [] : _ref$draws,
    onToggleDrawSelector = _ref.onToggleDrawSelector,
    selectedDrawNumber = _ref.selectedDrawNumber;
  const drawSelectorClassNames = ['pg_draw_selector', 'pg_draw_selector_list'];
  branding && drawSelectorClassNames.push("pg_draw_selector--".concat(branding));
  return React.createElement("div", {
    className: drawSelectorClassNames.join(' ')
  }, draws.map(draw => {
    const isSelected = draw.drawNumber === selectedDrawNumber;
    return React.createElement(DrawSelectorLinkItem, {
      drawNumber: draw.drawNumber,
      drawTitleForAnalytics: composeDrawTitleForAnalytics(draw),
      isLinkItem: !isSelected,
      key: draw.drawNumber,
      onToggleDrawSelector: onToggleDrawSelector,
      productId: draw.productId
    }, React.createElement(DrawCardContainer, {
      branding: branding,
      currentDraw: draw,
      drawCardVariant: DRAW_CARD_VARIANTS.SMALL,
      isListItem: true,
      isSelected: isSelected,
      key: draw.drawNumber,
      onToggleDrawSelector: onToggleDrawSelector
    }));
  }));
};
setGlobal('svs.components.tipsen.drawSelector.DrawSelectorList', DrawSelectorList);

 })(window);